import { CTNIcon } from '@ctn/ui/components/ctn-icon';
import classNames from 'classnames';
import React, { useMemo } from 'react';

import type { Icon } from '@ctn/ui/types/generic';

import { classNameCommon, classNameTemplate } from './config';

const classNameComponent = `${classNameCommon}-icon`;

const CardIconTemplate = ({
	className,
	icon,
	iconColor,
	title,
}: {
	readonly className?: string;
	readonly icon: Icon;
	readonly iconColor: string;
	readonly title: string | React.ReactElement;
}) => {
	const classNameCard = useMemo(() => classNames(classNameComponent, classNameTemplate, className), [className]);

	return (
		<div className={classNameCard}>
			<div className="c-pnp-card__wrap">
				<CTNIcon color={iconColor} icon={icon} size="size-64" />
				<p className="[ c-pnp-heading-h4 ] [ u-mt-16 ]">{title}</p>
			</div>
		</div>
	);
};

export default CardIconTemplate;
